import styles from './Issue.module.css';

import { useState } from "react";
import { Link } from "react-router-dom";
import { callSubmitGitHubIssue } from "../../api.js";
import { useAuth } from "../../AuthContext";

export const Issue = () => {
    const [ result, setResult ] = useState(null);
    const [ issue, setIssue ] = useState({ email: '', type: '', desc: '' });

    const { auth, token } = useAuth();

    const handleSubmitNewIssue = async () => {
        const ret = await callSubmitGitHubIssue(issue.email, issue.type, issue.desc, token);

        if (ret.error) {
            setResult(ret.error);
        } else {
            setResult('Issue submitted');
        }
    };

    return (
        <div className={ styles.container }>
            <div className={ styles.issue }>
                <div className={ styles.content }>
                    <input type="email" id="email" placeholder="Email Required" autoComplete="email" value={ (auth.currentUser && auth.currentUser.email) } disabled />

                    <select id="issueType" onChange={ (e) => setIssue({ ...issue, type: e.target.value }) }>
                        <option value="">select issue</option>
                        <option value="password">password</option>
                        <option value="email verification">email verification</option>
                        <option value="items">items</option>
                        <option value="other">other</option>
                    </select>

                    <textarea id="issueDescription" rows="4" cols="50" placeholder="describe the issue" required onChange={ (e) => setIssue({ ...issue, desc: e.target.value }) }></textarea>

                    <button id="submitIssueButton" onClick={ handleSubmitNewIssue } disabled={ !issue.email || !issue.type || !issue.desc }>submit</button>
                </div>

                { result && (
                    <div className={ styles.result }>{ result || 'submitting issue...' }</div>
                ) }

                <div className={ styles.close }>
                    <Link to="/">return to home page</Link>
                </div>
            </div>
        </div>
    );
};